import React from 'react';

const Footbar = () => {

    return (
        <div className="footer_wrap">
            <div className="footer_box">
                <div className="f_top">
                    <div className="f_logo"><a href="#"><img src="images/f_logo.png" alt=""/></a></div>
                    <div className="f_sns">
                        <a href="#"><img src="images/sns_line.png" alt=""/></a>
                        <a href="#"><img src="images/sns_wechat.png" alt=""/></a>
                        <a href="#"><img src="images/sns_facebook.png" alt=""/></a>
                        <a href="#"><img src="images/sns_twitter.png" alt=""/></a>
                        <a href="#"><img src="images/sns_instagram.png" alt=""/></a>
                        <a href="#"><img src="images/sns_youtube.png" alt=""/></a>
                    </div>
                </div>
                <img className="f_img" src="images/f_partners.png" alt=""/>
                <div className="f_text">
                    The Smurfs is a new online casino and mobile casino with 100s of the best casino games for you to enjoy 24 hours a day, 7 days a week,<br/>
                    365 days a year. Enjoy playing the best new casino games safely at our secure casino site in the comfort of your own home,or anywhere using your cellphone and mobile tablet device. Register or login now to play here at Ace Casino<br/>
                    and enjoy playing the best new casino games online and mobile. Casino players aged 18+/21+ from all around the world are welcome to play here including US casino players.<br/> 

                    The Smurfs hosts some of the best online slot games and mobile slot machines with 100s of the top slots games here for you to enjoy anytime. <br/>
                    We have slots ranging from $0.01 a spin rights up to jackpot slots with jackpots up to $1,000,000s to be win with one spin! So if you love to play penny pokies we have 100s of games for you. If you prefer to play high <br/>
                    stakes slots we also have 100s of games for you to play. We also have some of the most popular progressives where you can become a millionaire within seconds and one click of those reels. Register or login to play now. 			
                </div>
                <div className="f_copy">COPYRIGHT  2006~2023 The Smurfs ALL RIGHTS RESERVED.</div>
            </div>
        </div>
    );
};
export default Footbar;


// WEBPACK FOOTER //
// ./src/components/Layout/Footbar.js